import { CrudPage } from "@/components/admin/CrudPage";
import { F, In, Area, Toggle } from "@/components/admin/kit";

const BLANK = { question: "", answer: "", published: true, show_on_homepage: true };

const FaqForm = ({ value: v, set }) => (
  <div className="space-y-4">
    <F label="Question"><In value={v.question} onChange={set("question")} testid="faq-question" /></F>
    <F label="Answer"><Area value={v.answer} onChange={set("answer")} rows={5} testid="faq-answer" /></F>
    <Toggle label="Published" checked={v.published} onChange={set("published")} testid="faq-published" />
    <Toggle label="Show on homepage" checked={v.show_on_homepage} onChange={set("show_on_homepage")} testid="faq-homepage" />
  </div>
);

const Row = (f) => (
  <div><p className="font-semibold">{f.question}</p><p className="text-sm text-zinc-500 truncate">{f.answer}</p>{!f.published && <span className="text-xs text-zinc-600">Draft</span>}</div>
);

export default function FaqsAdmin() {
  return <CrudPage endpoint="faqs" title="FAQs" eyebrow="Content" label="FAQ" blank={BLANK} Form={FaqForm} renderRow={Row} testid="admin-faqs" />;
}
